import { AnimatePresence } from 'framer-motion'
import { useSelector } from 'react-redux'
import { getEnv } from '../../app/envs'
import { resetTimeLine } from '../../app/lib/timeline/timeline'
import { changeView, selectIsCashier } from '../../app/store/app/app.state'
import { selectFreeBets } from '../../app/store/betslip/betslip.selectors'
import {
  placeBet,
  resetGameData,
  selectGameFooterInfos,
} from '../../app/store/game/game.state'
import { useAppDispatch } from '../../app/store/store'
import { FreeRebet } from '../free-rebet/freeRebet'
import { Checkthick } from '../svgs'
import { Won, Wrapper, ButtonDone, RebetButton } from './gameFooter.style'

export const GameFooter = () => {
  const dispatch = useAppDispatch()
  const { currency } = getEnv()
  const isCashier = useSelector(selectIsCashier)
  const freeBetsList = useSelector(selectFreeBets)

  const { stake, status, wasFreeBet, win, visible, freeBetAmount, view } =
    useSelector(selectGameFooterInfos)

  const handleDone = () => {
    if (view !== 'betslip') {
      dispatch(changeView('betslip'))
    }
    dispatch(resetGameData())
    resetTimeLine()
  }

  const handleBetAgain = () => {
    dispatch(placeBet())
  }

  if (visible && isCashier && freeBetsList.length > 0) {
    return (
      <>
        {status === 1 && (
          <Won
            animate={{ y: -81 }}
            initial={{ y: 90 }}
            exit={{ y: 90 }}
            transition={{ ease: 'linear', duration: 0.2 }}
          >
            <div className="container">
              <div className="won-yes">YES!</div>
              <div className="won-txt">
                BET WON
                <Checkthick
                  width="16"
                  height="16"
                  viewBox="2 -5 28 28"
                  fill="#fff"
                />
              </div>
              <div className="won-amount">
                {currency} {win.toLocaleString()}
              </div>
            </div>
          </Won>
        )}

        <Wrapper
          data-testid="component-game-Footer"
          animate={{ y: 1 }}
          initial={{ y: 45 }}
          exit={{ y: 45 }}
          status={status}
          transition={{ ease: 'linear', duration: 0.2 }}
        >
          <FreeRebet />
        </Wrapper>
      </>
    )
  }

  return (
    <AnimatePresence>
      {visible && (
        <>
          {status === 1 && (
            <Won
              animate={{ y: -72 }}
              initial={{ y: 90 }}
              exit={{ y: 90 }}
              transition={{ ease: 'linear', duration: 0.2 }}
            >
              <div className="container">
                <div className="won-yes">YES!</div>
                <div className="won-txt">
                  BET WON
                  <Checkthick width="16" height="16" viewBox="2 -5 28 28" />
                </div>
                <div className="won-amount">
                  {currency} {win.toLocaleString()}
                </div>
              </div>
            </Won>
          )}
          <Wrapper
            data-testid="component-game-Footer"
            animate={{ y: 0 }}
            initial={{ y: 45 }}
            exit={{ y: 45 }}
            status={status}
            transition={{ ease: 'linear', duration: 0.2 }}
          >
            <ButtonDone
              data-testid="game-done"
              onClick={handleDone}
              width={wasFreeBet ? '100%' : '33%'}
              className="footer-btn"
            >
              Done
            </ButtonDone>

            {!wasFreeBet && !freeBetAmount && (
              <RebetButton onClick={handleBetAgain} className="footer-btn">
                {freeBetAmount ? (
                  <>
                    Free Bet: {currency} {freeBetAmount.toLocaleString()}
                  </>
                ) : (
                  <>
                    Rebet ({currency} {stake.toLocaleString()})
                  </>
                )}
              </RebetButton>
            )}
          </Wrapper>
        </>
      )}
    </AnimatePresence>
  )
}
